module.exports = __webpack_public_path__ + "static/media/convite2.82c2a71b.svg";